import React, { useState, useEffect } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { Box, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setLeads, setLoading } from '../../features/leads/leadSlice';
import { data } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const PrimaryTable = ({ columns = [], data = [],isLoading = false,totalRowCount = 0,fetchData, enableGlobalFilter = true, enableColumnPinning = true,sx }) => {


  
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 100 });
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');


  useEffect(() => {
    fetchData({
      pagination,
      sorting,
      columnFilters,
      globalFilter
    });
  }, [pagination, sorting, columnFilters, globalFilter]);


   // Function to convert data into an array of objects for export
   const prepareDataForExport = () => {
    // Get headers from the column definitions
    const headers = columns.map((col) => col.header);
    // Map through data and create objects with headers as keys
    const rows = data.map((item) => {
      const exportItem = {};
      columns.forEach((column) => {
        exportItem[column.header] = item[column.accessorKey] || ''; // Adjust based on your data structure
      });
      return exportItem;
    });

    return { headers, rows };
  };

  // CSV Export functionality
  const handleCsvExport = () => {
    const { headers, rows } = prepareDataForExport();
    return (
      <CSVLink
        data={[headers, ...rows.map(row => Object.values(row))]}
        filename={"exported_data.csv"}
        className="export-button"
        target="_blank"
      >
        Export CSV
      </CSVLink>
    );
  };

  // Excel Export functionality
  const handleExcelExport = () => {
    const { headers, rows } = prepareDataForExport();
    const ws = XLSX.utils.aoa_to_sheet([headers, ...rows.map(row => Object.values(row))]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Data');
    XLSX.writeFile(wb, 'exported_data.xlsx');
  };

  // PDF Export functionality
  const handlePdfExport = () => {
    const doc = new jsPDF();
    const { headers, rows } = prepareDataForExport();
    doc.autoTable({
      head: [headers],
      body: rows.map(row => Object.values(row)),
    });
    doc.save('exported_data.pdf');
  };


  return (
    <Box>


{/* <Box display="flex" justifyContent="flex-end" mb={2}>
     
        <Button variant="contained" color="primary" onClick={handleExcelExport}>
          Export Excel
        </Button>
        <Box ml={1}>
          {handleCsvExport()}
        </Box>
        <Box ml={1}>
          <Button variant="contained" color="primary" onClick={handlePdfExport}>
            Export PDF
          </Button>
        </Box>
      </Box> */}
      <MaterialReactTable
        columns={columns}
        data={data || []}
        manualPagination
        manualSorting
        manualFiltering
        rowCount={totalRowCount}
        onPaginationChange={setPagination}
        onSortingChange={setSorting}
        onColumnFiltersChange={setColumnFilters}
        onGlobalFilterChange={setGlobalFilter}
        state={{
          pagination,
          sorting,
          columnFilters,
          globalFilter,
          isLoading,
        }}
        enableGlobalFilter={enableGlobalFilter}
        enableColumnPinning={enableColumnPinning}
        enableColumnResizing
        enableSorting
        enableColumnOrdering
        enableDensityToggle
        muiTableContainerProps={{
          sx: sx || {},
          className: 'custom-scrollbar',
        }}
      />
    </Box>
  );
};

export default PrimaryTable;
